export default {
    accept_document: "Қабылдау",
    agreement_status_not_signed: "Қол қойылмаған",
    agreement_status_signed: "Қол қойылған",
    all_other_countries: "Басқа барлық елдер",
    effective_at: "Күшіне ену күні",
    legal_agreement: "Келісім",
    legal_document: "Заңды құжат",
    legal_document_countries_note: "Ешбір ел таңдалмаса, құжат осы түрдегі жеке құжаты жоқ барлық елдерге қолданылады.",
    legal_document_is_active_note: "Құжаттың әр түрі мен аймағы үшін тек бір нұсқа белсенді бола алады. Бұл нұсқаны белсендіру алдыңғы белсенді нұсқаны автоматты түрде өшіреді.",
    legal_document_must_accept_note: "Жұмысты жалғастыру үшін құжатпен танысып, оны қабылдау қажет.",
    legal_document_superadmin_authority_note: "Құжатты қабылдай отырып, сіз ұйым атынан әрекет етуге өкілеттігіңіз бар екенін растайсыз.",
    legal_document_type: "Құжат түрі",
    legal_document_type_offer_contract: "Оферта шарты",
    legal_document_type_integrations_agreement: "Үшінші тарап қызметтері мен интеграцияларды пайдалану келісімі",
    legal_document_type_usage_agreement: "Бағдарламаны пайдалану келісімі",
    legal_document_usage_agreement_note: "Құжатты қабылдай отырып, сіз бағдарламаны пайдалану ережелерімен танысқаныңызды және оларды сақтауға міндеттенетініңізді растайсыз.",
    legal_documents: "Заңды құжаттар",
    loading: "Жүктелуде",
    no_legal_documents_for_region: "Сіздің аймағыңыз үшін әлі бірде-бір құжат жарияланған жоқ",
    open_document: "Құжатты ашу",
    requires_reacceptance: "Қайта қабылдау талап етіледі",
    requires_reacceptance_note: "Қосылған болса, алдыңғы нұсқаны қабылдаған пайдаланушылар келесі кіруде осы нұсқаны қайта қабылдауы керек болады.",
    version: "Нұсқа"
}
